query UserMessageCounts {
  userMessageCounts {
    totalMessages
    repliesReceived
    messagesReceived
    messagesSent
  }
}
